module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="panel ';
 if (actual == true) { 
__p+=' panel-success ';
 } else { 
__p+=' panel-warning ';
 } 
__p+='"\r\n        title="';
 if (actual == true) { 
__p+=' Actual comment ';
 } else { 
__p+=' Not actual comment ';
 } 
__p+='">\r\n    <div class="panel-heading">\r\n        <div class="inline center text-muted">\r\n            '+
((__t=( (source || '') ))==null?'':__t)+
' &nbsp; '+
((__t=( (internal ? '(Internal)' : '(External)') ))==null?'':__t)+
'\r\n        </div>\r\n        <div class="pull-right inline" style="margin-left: 10px;">\r\n            '+
((__t=( time ))==null?'':__t)+
'\r\n        </div>\r\n        <div class="pull-right inline">\r\n            ';
 if (creatorId) { 
__p+='\r\n            <a href="/#person/'+
((__t=( creatorId ))==null?'':__t)+
'" target="_blank">'+
((__t=( creator ))==null?'':__t)+
'</a>\r\n            ';
 } else { 
__p+='\r\n            <a>ADMIN</a>\r\n            ';
 } 
__p+='\r\n        </div>\r\n    </div>\r\n    <div class="panel-body">\r\n        <div class="col-xs-10 col-md-10">\r\n            '+
((__t=( text ))==null?'':__t)+
'\r\n        </div>\r\n        ';
 if (canEdit) { 
__p+='\r\n        <div class="row pull-right col-xs-1 col-md-1 col-xs-offset-1 col-md-offset-1">\r\n            <a href="/#documents?commentId='+
((__t=( id ))==null?'':__t)+
'" target="_blank">\r\n                <span class="clickable glyphicon glyphicon-file" title="Related documents"/>\r\n            </a>\r\n            ';
 if (actual) { 
__p+='\r\n                <span class="clickable glyphicon glyphicon-erase set-as-irrelevant" style="margin-left: 5px;" title="Set as Irrelevant"></span>\r\n            ';
 } 
__p+='\r\n            ';
 if (false) { 
__p+='\r\n            <span class="clickable glyphicon glyphicon-edit edit-comment" title="Edit"></span>\r\n            <span class="clickable glyphicon glyphicon-remove remove-comment" style="margin-left: 5px;" title="Remove"></span>\r\n            ';
 } 
__p+='\r\n        </div>\r\n        ';
 } 
__p+='\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/comments/comments-row.html
// module id = 270
// module chunks = 0